export enum DocumentTypeMedcomms {
  MEDICAL_INITIATED_EMAILS = 'Medical Initiated Emails',
  SCIENTIFIC_CONTENT = 'Scientific Content',
}

export enum DocumentSubtypeMedcomms {
  SINGLE_TOPIC_PRESENTATION = 'Single-Topic Presentation',
  SCIENTIFIC_SUMMARY = 'Scientific Summary',
}
